import { createActions } from 'redux-actions';

export const {
  updateOceanResortSettings,
} = createActions('UPDATE_OCEAN_RESORT_SETTINGS');
